import { create } from 'zustand';

type State = {
  triggerToast: () => void;
  currentToast: JSX.Element | null;
};

type Action = {
  setTriggerToast: (triggerToast: () => void) => void;
  setCurrentToast: (toast: JSX.Element | null) => void;
};

const useNotifyStore = create<State & Action>((set) => ({
  triggerToast: () => {},
  setTriggerToast: (func) => set(() => ({ triggerToast: func })),

  currentToast: null,
  setCurrentToast: (toast) => set(() => ({ currentToast: toast })),
}));

export default useNotifyStore;
